import { IconProps } from "../../../types/style";

const DolorSingle = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
          fill={color}
        />
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          fill={color}
        />
        <path
          d="M19 7.75H16C15.59 7.75 15.25 7.41 15.25 7C15.25 6.59 15.59 6.25 16 6.25H19C19.41 6.25 19.75 6.59 19.75 7C19.75 7.41 19.41 7.75 19 7.75Z"
          fill={color}
        />
        <path
          d="M8 17.75H5C4.59 17.75 4.25 17.41 4.25 17C4.25 16.59 4.59 16.25 5 16.25H8C8.41 16.25 8.75 16.59 8.75 17C8.75 17.41 8.41 17.75 8 17.75Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default DolorSingle;
